import { AxiosResponse } from 'axios';
import { SET_SCREEN_ARTBOARDS, SET_SCREEN_ARTBOARD, SET_SCREEN_ARTBOARD_CONTENT, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_SCREEN_ARTBOARD_ISLOADING,
  DELETE_SCREEN_ARTBOARD,
  EDIT_SCREEN_ARTBOARD,
  GET_SCREEN_ARTBOARD,
  GET_SCREEN_ARTBOARD_CONTENT,
  GET_SCREEN_ARTBOARDS,
  REGISTER_SCREEN_ARTBOARD,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import ScreenArtboard from '@/services/screen_artboard';
import { Module } from 'vuex';
import { EditScreenArtboard, RegisterScreenArtboard, GetScreenArtboard } from '@/dtos/screen_artboard.dto';

const screenArtboard: Module<any, {}> = {
  state: {
    screenArtboard: {
      data: null,
      isLoading: false,
    },
    screenArtboards: {
      data: null,
      isLoading: false,
    },
    screenArtboardContent: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    screenArtboard: (state: { screenArtboard: any }) => state.screenArtboard,
    screenArtboards: (state: { screenArtboards: any }) => state.screenArtboards,
    screenArtboardContent: (state: { screenArtboardContent: any }) => state.screenArtboardContent,
  },
  mutations: {
    [SET_SCREEN_ARTBOARD]: (
      state: { screenArtboard: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.screenArtboard.data = payload.data) : null,
        (state.screenArtboard.isLoading = payload.isLoading);
    },
    [SET_SCREEN_ARTBOARDS]: (
      state: { screenArtboards: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.screenArtboards.data = payload.data) : null,
        (state.screenArtboards.isLoading = payload.isLoading);
    },
    [SET_SCREEN_ARTBOARD_CONTENT]: (
      state: { screenArtboardContent: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.screenArtboardContent.data = payload.data) : null,
        (state.screenArtboardContent.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_SCREEN_ARTBOARD]: async ({ commit }: any, payload: any) => {
      commit(SET_SCREEN_ARTBOARD, { data: null, isLoading: true });

      const result: AxiosResponse = await ScreenArtboard.registerScreenArtboard(
        payload as RegisterScreenArtboard
      );

      if (result) {
        if (result.data.status) {
          commit(SET_SCREEN_ARTBOARD, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SCREEN_ARTBOARD, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN_ARTBOARD, { isLoading: false });
        return false;
      }
    },
    [GET_SCREEN_ARTBOARDS]: async ({ commit }: any, payload: any) => {
      commit(SET_SCREEN_ARTBOARDS, { data: null, isLoading: true });

      const result: AxiosResponse = await ScreenArtboard.getScreenArtboards(
        payload as GetScreenArtboard
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREEN_ARTBOARDS, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_SCREEN_ARTBOARDS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN_ARTBOARDS, { isLoading: false });
        return false;
      }
    },
    [GET_SCREEN_ARTBOARD]: async ({ commit }: any, payload: any) => {
      commit(SET_SCREEN_ARTBOARD, { data: null, isLoading: true });

      const result: AxiosResponse = await ScreenArtboard.getScreenArtboards(
        payload as GetScreenArtboard
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREEN_ARTBOARD, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_SCREEN_ARTBOARD, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN_ARTBOARD, { isLoading: false });
        return false;
      }
    },
    [GET_SCREEN_ARTBOARD_CONTENT]: async ({ commit }: any, payload: any) => {
      commit(SET_SCREEN_ARTBOARD_CONTENT, { data: null, isLoading: true });

      const result: AxiosResponse = await ScreenArtboard.getScreenArtboardContent(
        payload as GetScreenArtboard
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.dataCONTENT', result.data.data);
          commit(SET_SCREEN_ARTBOARD_CONTENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SCREEN_ARTBOARD_CONTENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN_ARTBOARD_CONTENT, { isLoading: false });
        return false;
      }
    },
    [EDIT_SCREEN_ARTBOARD]: async ({ commit }: any, payload: any) => {
      commit(SET_SCREEN_ARTBOARD, { data: null, isLoading: true });

      const result: AxiosResponse = await ScreenArtboard.editScreenArtboard(
        payload as EditScreenArtboard
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREEN_ARTBOARD, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_SCREEN_ARTBOARD, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN_ARTBOARD, { isLoading: false });
        return false;
      }
    },
    [DELETE_SCREEN_ARTBOARD]: async ({ commit }: any, payload: string) => {
      commit(SET_SCREEN_ARTBOARD, { data: null, isLoading: true });

      const result: AxiosResponse = await ScreenArtboard.deleteScreenArtboard(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SCREEN_ARTBOARD, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SCREEN_ARTBOARD, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SCREEN_ARTBOARD, { isLoading: false });
        return false;
      }
    },
    [CLEAR_SCREEN_ARTBOARD_ISLOADING]: ({ commit }) => {
      commit(SET_SCREEN_ARTBOARD, { isLoading: false });
      commit(SET_SCREEN_ARTBOARDS, { isLoading: false });
    },
  },
};

export default screenArtboard;
